import { render, staticRenderFns } from "./ProviderAuth.vue?vue&type=template&id=cf31fedc&"
import script from "./ProviderAuth.vue?vue&type=script&lang=js&"
export * from "./ProviderAuth.vue?vue&type=script&lang=js&"
import style0 from "./ProviderAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports